import { render, staticRenderFns } from "./scene3.vue?vue&type=template&id=d6bb264e&scoped=true&"
import script from "./scene3.vue?vue&type=script&lang=ts&"
export * from "./scene3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bb264e",
  null
  
)

export default component.exports